import { render } from "./signup-otp.vue?vue&type=template&id=bfa3ad5a"
import script from "./signup-otp.vue?vue&type=script&lang=js"
export * from "./signup-otp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__